import { useState } from 'react';
import { eventService } from 'services/api';
import styles from './InviteModal.module.css';

// ── Enviar invitación por correo (a todos o a los seleccionados) ──────────────
export default function InviteModal({ eventId, selectedIds, onClose, onSent }) {
  const selectedCount = selectedIds.length;
  const [mode,    setMode]    = useState(selectedCount > 0 ? 'selected' : 'all');
  const [sending, setSending] = useState(false);
  const [error,   setError]   = useState('');

  const submit = async () => {
    setSending(true); setError('');
    try {
      const body = mode === 'all' ? { all: true } : { guest_ids: selectedIds };
      const { data } = await eventService.invite(eventId, body);
      onSent(data.message || 'Envío iniciado');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al iniciar el envío');
      setSending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.modalInvitar}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className={`fas fa-envelope ${styles.iconoTitulo}`} />Enviar invitación</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className={`modal-body ${styles.cuerpo}`}>
          {error && <div className="alert alert-danger">{error}</div>}
          <p className={styles.nota}>
            Se enviará un correo con la información del evento y el QR de acceso a cada invitado con correo registrado.
          </p>
          <label className={styles.opcion}>
            <input type="radio" checked={mode === 'all'} onChange={() => setMode('all')} />
            Todos los invitados de este evento
          </label>
          <label className={selectedCount ? styles.opcion : styles.opcionBloqueada}>
            <input type="radio" checked={mode === 'selected'} disabled={!selectedCount} onChange={() => setMode('selected')} />
            Solo los seleccionados ({selectedCount})
          </label>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn btn-primary" disabled={sending} onClick={submit}>
            {sending ? <><i className="fas fa-spinner fa-spin" /> Enviando...</> : <><i className="fas fa-paper-plane" /> Enviar</>}
          </button>
        </div>
      </div>
    </div>
  );
}
